import axiosInstance from '@/lib/api-client';
import { API_ENDPOINTS } from '@/lib/api-endpoint';
import { User } from '@/components/users/UserTable';

export type UserWithoutId = {
  name: string;
  email: string;
  role: string;
  password: string;
  status?: 'active' | 'inactive';
};

export async function fetchUsers(): Promise<User[]> {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.USERS);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

export async function createUser(userData: UserWithoutId): Promise<User> {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.USERS, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function fetchUserById(userId: string): Promise<User> {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.USER(userId));
    return response.data;
  } catch (error) {
    console.error(`Error fetching user ${userId}:`, error);
    throw error;
  }
}

export async function updateUser(userId: string, userData: Partial<User>): Promise<User> {
  try {
    const response = await axiosInstance.patch(API_ENDPOINTS.USER(userId), userData);
    return response.data;
  } catch (error) {
    console.error(`Error updating user ${userId}:`, error);
    throw error;
  }
}

export async function updateUserStatus(userId: string, status: 'active' | 'inactive'): Promise<User> {
  try {
    const response = await axiosInstance.patch(API_ENDPOINTS.USER(userId), { status });
    return response.data;
  } catch (error) {
    console.error(`Error updating user status ${userId}:`, error);
    throw error;
  }
}

export async function deleteUser(userId: string): Promise<void> {
  try {
    await axiosInstance.delete(API_ENDPOINTS.USER(userId));
  } catch (error) {
    console.error(`Error deleting user ${userId}:`, error);
    throw error;
  }
} 